// import {
//     Button,
//     useColorModeValue,
//     Table,
//     Thead,
//     Tbody,
//     Tr,
//     Th,
//     Td,
//     TableContainer,
//     Center,
//     VStack,
//     Input,
//     Badge,
//     Text,
//     Box,
//     HStack,
//     IconButton,
//     Select,
//     Tooltip,
//     Flex,
//     Icon
// } from '@chakra-ui/react';
// import React, { useEffect, useState, useMemo, useCallback } from 'react';
// import { useGetUsersDataMutation } from "../../slices/adminApiSlice";
// import Loader from "../../components/Loader";
// import { 
//     FaChevronDown, 
//     FaChevronUp, 
//     FaChevronRight, 
//     FaChevronLeft, 
//     FaSearch, 
//     FaFilter,
//     FaUser, 
//     FaEnvelope, 
//     FaPhone, 
//     FaStamp, 
//     FaExchangeAlt,
//     FaCoins, 
//     FaGift, 
//     FaAward, 
//     FaCalendarAlt,
//     FaSort,
//     FaSortUp,
//     FaSortDown,
//     FaFileExport
// } from 'react-icons/fa';

// export default function UserManagementScreen() {
//     // Color scheme definitions
    
//     const colors = {
//         primary: useColorModeValue('teal.500', 'teal.600'),
//         primaryDark: useColorModeValue('teal.600', 'teal.400'),
//         background: useColorModeValue('gray.50', 'gray.800'),
//         cardBg: useColorModeValue('white', 'gray.700'),
//         text: useColorModeValue('gray.700', 'gray.200'),
//         border: useColorModeValue('gray.200', 'gray.600'),
//         hover: useColorModeValue('teal.50', 'teal.900'),
//         bg: useColorModeValue('teal.50', 'gray.800'),
//         th: useColorModeValue('teal.600', 'teal.800')
//     };

//     const [searchQuery, setSearchQuery] = useState('');
//     const [expandedRowId, setExpandedRowId] = useState(null);
//     const [usersData, setUsersData] = useState([]);
//     const [usersTransactions, setUsersTransactions] = useState([]);
//     const [getUsersData, { isLoading }] = useGetUsersDataMutation();
//     const [sortColumn, setSortColumn] = useState('createdAt');
//     const [sortOrder, setSortOrder] = useState('desc');
//     const [currentPage, setCurrentPage] = useState(1);
//     const usersPerPage = 10;

//     // Transaction configuration - PER USER STATE
//     const [userTransactionPages, setUserTransactionPages] = useState({});
//     const [userTransactionFilters, setUserTransactionFilters] = useState({});
//     const [userTransactionSortConfig, setUserTransactionSortConfig] = useState({});
//     const [userTransactionSearch, setUserTransactionSearch] = useState({});
//     const transactionsPerPage = 10;

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await getUsersData().unwrap();
//                 setUsersData(response.users || []);
//                 setUsersTransactions(response.transactions);
//             } catch (error) {
//                 console.error('Error fetching users:', error);
//             }
//         };
//         fetchData();
//     }, [getUsersData]);

//     // Sorting and filtering for users
//     const filteredUsers = useMemo(() => usersData.filter(user => {
//         const query = searchQuery.toLowerCase();
//         return [user.email, user.phone, user.name].some(field => field?.toLowerCase().includes(query));
//     }), [usersData, searchQuery]);

//     const sortedUsers = useMemo(() => [...filteredUsers].sort((a, b) => {
//         let aValue, bValue;

//         if (sortColumn === 'reward_count') {
//             aValue = a.reward_history?.length || 0;
//             bValue = b.reward_history?.length || 0;
//         } else {
//             aValue = a[sortColumn]?.toString().toLowerCase() || '';
//             bValue = b[sortColumn]?.toString().toLowerCase() || '';
//         }

//         return sortOrder === 'asc' ? (aValue > bValue ? 1 : -1) : (aValue > bValue ? -1 : 1);
//     }), [filteredUsers, sortColumn, sortOrder]);

//     const totalPages = Math.ceil(sortedUsers.length / usersPerPage);
//     const paginatedUsers = useMemo(() => sortedUsers.slice((currentPage - 1) * usersPerPage, currentPage * usersPerPage), [sortedUsers, currentPage]);

//     // Transaction per-user state management functions
//     const getCurrentTranPageForUser = useCallback((userId) => {
//         return userTransactionPages[userId] || 1;
//     }, [userTransactionPages]);

//     const getFilterForUser = useCallback((userId) => {
//         return userTransactionFilters[userId] || 'all';
//     }, [userTransactionFilters]);

//     const getSortConfigForUser = useCallback((userId) => {
//         return userTransactionSortConfig[userId] || { key: 'createdAt', direction: 'desc' };
//     }, [userTransactionSortConfig]);

//     const getSearchForUser = useCallback((userId) => {
//         return userTransactionSearch[userId] || '';
//     }, [userTransactionSearch]);

//     // Transaction state update functions
//     const handleTranPageChange = useCallback((userId, page) => {
//         if (userId && page >= 1) {
//             setUserTransactionPages(prev => ({
//                 ...prev,
//                 [userId]: page
//             }));
//         }
//     }, []);

//     const handleFilterChange = useCallback((userId, filter) => {
//         if (userId) {
//             setUserTransactionFilters(prev => ({
//                 ...prev,
//                 [userId]: filter
//             }));
//             // Reset to page 1 when filter changes
//             setUserTransactionPages(prev => ({
//                 ...prev,
//                 [userId]: 1
//             }));
//         }
//     }, []);

//     const handleSearchChange = useCallback((userId, search) => {
//         if (userId) {
//             setUserTransactionSearch(prev => ({
//                 ...prev,
//                 [userId]: search
//             }));
//             // Reset to page 1 when search changes
//             setUserTransactionPages(prev => ({
//                 ...prev,
//                 [userId]: 1
//             }));
//         }
//     }, []);

//     const handleSortChange = useCallback((userId, key) => {
//         if (userId) {
//             setUserTransactionSortConfig(prev => {
//                 const currentConfig = prev[userId] || { key: 'createdAt', direction: 'desc' };
//                 let direction = 'asc';
//                 if (currentConfig.key === key && currentConfig.direction === 'asc') {
//                     direction = 'desc';
//                 }
//                 return {
//                     ...prev,
//                     [userId]: { key, direction }
//                 };
//             });
//         }
//     }, []);

//     // Reset to defaults when expanding a row
//     const toggleRowExpansion = useCallback((id) => {
//         setExpandedRowId(prev => {
//             const newId = prev === id ? null : id;
//             // Reset to defaults when expanding a new row
//             if (newId !== prev && newId !== null) {
//                 setUserTransactionPages(prevPages => ({
//                     ...prevPages,
//                     [newId]: 1
//                 }));
//                 setUserTransactionFilters(prevFilters => ({
//                     ...prevFilters,
//                     [newId]: 'all'
//                 }));
//                 setUserTransactionSortConfig(prevSort => ({
//                     ...prevSort,
//                     [newId]: { key: 'createdAt', direction: 'desc' }
//                 }));
//                 setUserTransactionSearch(prevSearch => ({
//                     ...prevSearch,
//                     [newId]: ''
//                 }));
//             }
//             return newId;
//         });
//     }, []);

//     // Transactions filtering and sorting
//     const getSortedAndFilteredTransactions = useCallback((transactions, userId) => {
//         let filtered = transactions;

//         // Get user-specific filters
//         const filter = getFilterForUser(userId);
//         const search = getSearchForUser(userId);
//         const sortConfig = getSortConfigForUser(userId);

//         // Apply type filtering
//         if (filter !== 'all') {
//             filtered = filtered.filter(transaction => transaction.type === filter);
//         }

//         // Apply search filtering
//         if (search) {
//             filtered = filtered.filter((transaction) => {
//                 return (
//                     transaction.invoice_id?.toLowerCase().includes(search.toLowerCase()) ||
//                     transaction.type?.toLowerCase().includes(search.toLowerCase()) ||
//                     transaction.amount?.toString().includes(search) ||
//                     transaction.added_by_name?.toLowerCase().includes(search.toLowerCase())
//                 );
//             });
//         }

//         // Apply sorting
//         if (sortConfig.key) {
//             filtered.sort((a, b) => {
//                 let aValue, bValue;

//                 if (sortConfig.key === 'amount') {
//                     aValue = a.amount;
//                     bValue = b.amount;
//                 } else if (sortConfig.key === 'createdAt' || sortConfig.key === 'expiration_date') {
//                     aValue = new Date(a[sortConfig.key]);
//                     bValue = new Date(b[sortConfig.key]);
//                 } else {
//                     aValue = a[sortConfig.key]?.toString().toLowerCase();
//                     bValue = b[sortConfig.key]?.toString().toLowerCase();
//                 }

//                 if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
//                 if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
//                 return 0;
//             });
//         }

//         return filtered;
//     }, [getFilterForUser, getSearchForUser, getSortConfigForUser]);

//     const handleSort = (column) => {
//         setSortOrder(sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc');
//         setSortColumn(column);
//     };

//     const getBadgeColor = (type) => {
//         const colorMap = {
//             earn: 'green',
//             redeem: 'red',
//             expired: 'purple',
//             earn_stamp: 'blue',
//             redeem_stamp: 'orange',
//             expired_stamp: 'pink',
//         };
//         return colorMap[type] || 'gray';
//     };

//     const columnNames = {
//         invoice_id: 'Invoice ID',
//         amount: 'Amount',
//         type: 'Type',
//         stamps: 'Stamps',
//         points: 'Points',
//         added_by_name: 'Added By',
//         createdAt: 'Created At',
//         expiration_date: 'Expiration Date',
//     };
      
//     const getBadgeLabel = (type) => {
//         const labelMap = {
//             earn: 'Earned',
//             redeem: 'Redeemed',
//             expired: 'Expired',
//             earn_stamp: 'Earned Stamp',
//             redeem_stamp: 'Redeemed Stamp',
//             expired_stamp: 'Expired Stamp',
//         };
//         return labelMap[type] || 'Unknown';
//     };

//     const transactionTypes = [
//         { value: 'all', label: 'All Types' },
//         { value: 'earn', label: 'Earned' },
//         { value: 'redeem', label: 'Redeemed' },
//         { value: 'expired', label: 'Expired' },
//         { value: 'earn_stamp', label: 'Earned Stamp' },
//         { value: 'redeem_stamp', label: 'Redeemed Stamp' },
//         { value: 'expired_stamp', label: 'Expired Stamp' },
//     ];

//     // Memoized column configuration
//     const columns = useMemo(() => [
//         { key: 'name', label: 'Name', icon: FaUser, tooltip: 'Customer name', colorScheme: 'blue' },
//         { key: 'email', label: 'Email', icon: FaEnvelope, tooltip: 'Customer email address', colorScheme: 'teal' },
//         { key: 'phone', label: 'Phone', icon: FaPhone, tooltip: 'Contact phone number', colorScheme: 'cyan' },
//         { key: 'current_stamps', label: 'Current Stamps', icon: FaStamp, tooltip: 'Available stamps in account', colorScheme: 'orange', numeric: true },
//         { key: 'total_stamps_redeemed', label: 'Used Stamps', icon: FaExchangeAlt, tooltip: 'Total stamps redeemed', colorScheme: 'red', numeric: true },
//         { key: 'current_points', label: 'Current Points', icon: FaCoins, tooltip: 'Available reward points', colorScheme: 'yellow', numeric: true },
//         { key: 'total_points_redeemed', label: 'Used Points', icon: FaGift, tooltip: 'Total points redeemed', colorScheme: 'pink', numeric: true },
//         { key: 'reward_count', label: 'Reward Count', icon: FaAward, tooltip: 'Number of rewards claimed', colorScheme: 'purple', numeric: true },
//         { key: 'createdAt', label: 'Created At', icon: FaCalendarAlt, tooltip: 'Account creation date', colorScheme: 'gray' }
//     ], []);

//     // Tooltip wrapper component
//     const TooltipWrapper = useCallback(({ children, label, colorScheme }) => (
//         label ? (
//             <Tooltip label={`Sort by ${label}`} hasArrow placement="top" bg={`${colorScheme}.500`}>
//                 {children}
//             </Tooltip>
//         ) : (
//             <>{children}</>
//         )
//     ), []);
    
//     const exportData = useCallback(() => {
//         // Prepare data for export
//         const dataToExport = sortedUsers.map(user => ({
//           Name: user.name,
//           Email: user.email,
//           Phone: user.phone,
//           'Current Stamps': user.current_stamps,
//           'Used Stamps': user.total_stamps_redeemed,
//           'Current Points': user.current_points,
//           'Used Points': user.total_points_redeemed,
//           'Reward Count': user.reward_history?.length || 0,
//           'Created At': new Date(user.createdAt).toLocaleDateString('en-GB')
//         }));
      
//         // Convert to CSV
//         const csvContent = [
//           Object.keys(dataToExport[0]).join(','), // Header row
//           ...dataToExport.map(item => Object.values(item).join(','))
//         ].join('\n');
      
//         // Create download link
//         const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', `users_export_${new Date().toISOString().slice(0,10)}.csv`);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//       }, [sortedUsers]);

//     return (
//         <VStack spacing={6} align="stretch" p={4} bg={colors.background} minH="100vh">
//             {/* Search Header */}
//                 <HStack spacing={4}>
//                     <Box position="relative" flex={1}>
//                         <Input
//                             bg={colors.cardBg}
//                             placeholder="Search users by name, email or phone..."
//                             value={searchQuery}
//                             onChange={(e) => setSearchQuery(e.target.value)}
//                             size="lg"
//                             borderRadius="lg"
//                             pl={10}
//                             _focus={{ 
//                                 borderColor: colors.primary,
//                                 boxShadow: `0 0 0 1px ${colors.primary}`
//                             }}
//                         />
//                         <Box position="absolute" left={3} top="50%" transform="translateY(-50%)" color={colors.text}>
//                             <FaSearch />
//                         </Box>
//                     </Box>
//                     <Button 
//                         colorScheme="teal" 
//                         px={6}
//                         borderRadius="lg"
//                         variant="outline"
//                         onClick={exportData}
//                         isLoading={isLoading}
//                         leftIcon={<FaFileExport />}
//                         >
//                         Export
//                     </Button>
//                 </HStack>

//             {/* Main Table */}
//                 <TableContainer
//                     borderRadius="lg"
//                     borderWidth="1px"
//                     borderColor={colors.border}
//                     bg={colors.cardBg}
//                     boxShadow="sm"
//                 >
//                     {isLoading ? (
//                         <Center minH="300px">
//                             <Loader color={colors.cardBg} minH={'50vh'} />
//                         </Center>
//                     ) : paginatedUsers.length ? (
//                         <Table size="sm" variant="simple">
//                            <Thead bg={colors.primary}>
//                             <Tr>
//                                 {columns.map((column) => (
//                                     <Th 
//                                         key={column.key}
//                                         color="white"
//                                         onClick={() => handleSort(column.key)}
//                                         cursor="pointer"
//                                         _hover={{ 
//                                             bg: colors.th,
//                                             transform: 'translateY(-2px)'
//                                         }}
//                                         transition="all 0.2s"
//                                         py={4}
//                                         textAlign={column.numeric ? 'right' : 'left'}
//                                         aria-sort={
//                                             sortColumn === column.key ? 
//                                             (sortOrder === 'asc' ? 'ascending' : 'descending') : 
//                                             'none'
//                                         }
//                                     >
//                                         <TooltipWrapper label={column.tooltip} colorScheme={column.colorScheme}>
//                                             <Flex align="center" gap={3}>
//                                                 <Center
//                                                     w={8}
//                                                     h={8}
//                                                     borderRadius="md"
//                                                     bg={`${column.colorScheme}.100`}
//                                                     color={`${column.colorScheme}.600`}
//                                                     flexShrink={0}
//                                                 >
//                                                     <Icon as={column.icon} boxSize={4} />
//                                                 </Center>
//                                                 <Text fontWeight="semibold">{column.label}</Text>
//                                                 <Icon
//                                                     as={
//                                                         sortColumn === column.key
//                                                             ? sortOrder === 'asc'
//                                                                 ? FaSortUp
//                                                                 : FaSortDown
//                                                             : FaSort
//                                                     }
//                                                     color={sortColumn === column.key ? 'white' : 'whiteAlpha.600'}
//                                                     ml={1}
//                                                     boxSize={4}
//                                                 />
//                                             </Flex>
//                                         </TooltipWrapper>
//                                     </Th>
//                                 ))}
//                                 <Th color="white">Actions</Th>
//                             </Tr>
//                         </Thead>
//                             <Tbody>
//                                 {paginatedUsers.map((user) => {
//                                     const transactions = usersTransactions.filter(transaction => transaction.user === user._id);
//                                     const hasTransactions = transactions.length > 0;
//                                     const currentTranPageForUser = getCurrentTranPageForUser(user._id);
//                                     const currentFilterForUser = getFilterForUser(user._id);
//                                     const currentSearchForUser = getSearchForUser(user._id);
//                                     const currentSortConfigForUser = getSortConfigForUser(user._id);
//                                     const filteredTransactions = getSortedAndFilteredTransactions(transactions, user._id);
//                                     const totalTranPages = Math.ceil(filteredTransactions.length / transactionsPerPage);

//                                     return (
//                                         <React.Fragment key={user._id}>
//                                             <Tr 
//                                                 _hover={{ bg: colors.hover }}
//                                                 borderBottomWidth={expandedRowId === user._id ? '0' : '1px'}
//                                                 borderBottomColor={colors.border}
//                                             >
//                                                 <Td fontWeight="medium">{user.name || 'N/A'}</Td>
//                                                 <Td>{user.email}</Td>
//                                                 <Td>{user.phone || 'N/A'}</Td>
//                                                 <Td textAlign={'center'} fontWeight="bold">{user.current_stamps}</Td>
//                                                 <Td textAlign={'center'} fontWeight="bold">{user.total_stamps_redeemed}</Td>
//                                                 <Td textAlign={'center'} fontWeight="bold">{user.current_points}</Td>
//                                                 <Td textAlign={'center'} fontWeight="bold">{user.total_points_redeemed}</Td>
//                                                 <Td textAlign={'center'} fontWeight="bold">{user.reward_history?.length || 0}</Td>                   
//                                                 <Td>{new Date(user.createdAt).toLocaleDateString('en-GB')}</Td>
//                                                 <Td>
//                                                     <HStack spacing={2} justify="center">
//                                                         <IconButton
//                                                             aria-label={expandedRowId === user._id ? "Collapse transactions" : "Expand transactions"}
//                                                             icon={expandedRowId === user._id ? <FaChevronUp /> : <FaChevronDown />}
//                                                             onClick={() => toggleRowExpansion(user._id)}
//                                                             size="sm"
//                                                             colorScheme="teal"
//                                                             variant="ghost"
//                                                             isDisabled={!hasTransactions}
//                                                             _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
//                                                         />
//                                                     </HStack>
//                                                 </Td>
//                                             </Tr>

//                                             {expandedRowId === user._id && (
//                                                 <Tr>
//                                                     <Td colSpan={10} p={0}>
//                                                         <Box 
//                                                             bg={colors.bg}
//                                                             p={4}
//                                                             borderRadius="lg"
//                                                             borderWidth="1px"
//                                                             borderColor={colors.border}
//                                                         >
//                                                             <VStack spacing={4} align="stretch">
//                                                                 <HStack spacing={4}>
//                                                                     <Box position="relative" flex={1}>
//                                                                         <Input
//                                                                             placeholder="Search transactions..."
//                                                                             value={currentSearchForUser}
//                                                                             onChange={(e) => handleSearchChange(user._id, e.target.value)}
//                                                                             size="sm"
//                                                                             borderRadius="md"
//                                                                             pl={8}
//                                                                             _focus={{ 
//                                                                                 borderColor: colors.primary,
//                                                                                 boxShadow: `0 0 0 1px ${colors.primary}`
//                                                                             }}
//                                                                         />
//                                                                         <Box position="absolute" left={3} top="50%" transform="translateY(-50%)" color={colors.text}>
//                                                                             <FaSearch size={14} />
//                                                                         </Box>
//                                                                     </Box>
//                                                                     <Select
//                                                                         value={currentFilterForUser}
//                                                                         onChange={(e) => handleFilterChange(user._id, e.target.value)}
//                                                                         size="sm"
//                                                                         borderRadius="md"
//                                                                         width="200px"
//                                                                         icon={<FaFilter size={12} />}
//                                                                     >
//                                                                         {transactionTypes.map(type => (
//                                                                             <option key={type.value} value={type.value}>
//                                                                                 {type.label}
//                                                                             </option>
//                                                                         ))}
//                                                                     </Select>
//                                                                 </HStack>

//                                                                 <TableContainer
//                                                                     borderRadius="lg"
//                                                                     borderWidth="1px"
//                                                                     borderColor={colors.border}
//                                                                     bg={colors.cardBg}
//                                                                     boxShadow="sm"
//                                                                 >
//                                                                     <Table size="sm" variant="simple">
//                                                                         <Thead
//                                                                             bg={colors.primary}
//                                                                             position="sticky"
//                                                                             top={0}
//                                                                             zIndex={1}
//                                                                         >
//                                                                             <Tr>
//                                                                                 {['invoice_id', 'amount', 'type', 'stamps', 'points', 'added_by_name', 'createdAt', 'expiration_date'].map((column) => (
//                                                                                     <Th
//                                                                                         key={column}
//                                                                                         color="white"
//                                                                                         onClick={() => handleSortChange(user._id, column)}
//                                                                                         cursor="pointer"
//                                                                                         _hover={{ bg: colors.primaryDark }}
//                                                                                         py={3}
//                                                                                     >
//                                                                                         <HStack spacing={1}>
//                                                                                             <Text>{columnNames[column] || column.replace(/_/g, ' ')}</Text>
//                                                                                             {currentSortConfigForUser.key === column && (
//                                                                                                 currentSortConfigForUser.direction === 'asc' ? 
//                                                                                                     <FaChevronUp size={10} /> : 
//                                                                                                     <FaChevronDown size={10} />
//                                                                                             )}
//                                                                                         </HStack>
//                                                                                     </Th>
//                                                                                 ))}
//                                                                             </Tr>
//                                                                         </Thead>
//                                                                         <Tbody>
//                                                                             {filteredTransactions
//                                                                                 .slice(
//                                                                                     (currentTranPageForUser - 1) * transactionsPerPage,
//                                                                                     currentTranPageForUser * transactionsPerPage
//                                                                                 )
//                                                                                 .map((transaction) => (
//                                                                                     <Tr 
//                                                                                         key={`${transaction._id}-${user._id}`} 
//                                                                                         _hover={{ bg: colors.hover }}
//                                                                                     >
//                                                                                         <Td fontSize="sm">{transaction.invoice_id}</Td>
//                                                                                         <Td fontWeight="medium">
//                                                                                             {new Intl.NumberFormat('en-US', {
//                                                                                                 minimumFractionDigits: 0,
//                                                                                                 maximumFractionDigits: 0,
//                                                                                             }).format(transaction.amount)} MMK
//                                                                                         </Td>
//                                                                                         <Td>
//                                                                                             <Badge 
//                                                                                                 colorScheme={getBadgeColor(transaction.type)}
//                                                                                                 variant="subtle"
//                                                                                                 px={2}
//                                                                                                 py={1}
//                                                                                                 borderRadius="full"
//                                                                                             >
//                                                                                                 {getBadgeLabel(transaction.type)}
//                                                                                             </Badge>
//                                                                                         </Td>
//                                                                                         <Td>{transaction.stamps}</Td>
//                                                                                         <Td>{transaction.points}</Td>
//                                                                                         <Td>{transaction.added_by_name}</Td>
//                                                                                         <Td>{new Date(transaction.createdAt).toLocaleDateString('en-GB')}</Td>
//                                                                                         <Td>
//                                                                                             {transaction.expiration_date ? (
//                                                                                                 new Date(transaction.expiration_date).toLocaleDateString('en-GB')
//                                                                                             ) : (
//                                                                                                 <Badge colorScheme="gray" variant="outline">N/A</Badge>
//                                                                                             )}
//                                                                                         </Td>
//                                                                                     </Tr>
//                                                                                 ))}
//                                                                         </Tbody>
//                                                                     </Table>
//                                                                 </TableContainer>

//                                                                 <HStack justify="space-between" mt={4}>
//                                                                     <Text fontSize="sm" color={colors.text}>
//                                                                         Showing {(currentTranPageForUser - 1) * transactionsPerPage + 1} to{' '}
//                                                                         {Math.min(
//                                                                             currentTranPageForUser * transactionsPerPage,
//                                                                             filteredTransactions.length
//                                                                         )} of {filteredTransactions.length} transactions
//                                                                     </Text>
//                                                                     <HStack spacing={2}>
//                                                                         <IconButton
//                                                                             aria-label="Previous page"
//                                                                             icon={<FaChevronUp />}
//                                                                             size="sm"
//                                                                             onClick={() => handleTranPageChange(user._id, currentTranPageForUser - 1)}
//                                                                             isDisabled={currentTranPageForUser === 1}
//                                                                             colorScheme="teal"
//                                                                             variant="outline"
//                                                                         />
//                                                                         <Select
//                                                                             value={currentTranPageForUser}
//                                                                             onChange={(e) => handleTranPageChange(user._id, Number(e.target.value))}
//                                                                             size="sm"
//                                                                             width="80px"
//                                                                             borderRadius="md"
//                                                                         >
//                                                                             {Array.from(
//                                                                                 { length: totalTranPages },
//                                                                                 (_, i) => (
//                                                                                     <option key={i + 1} value={i + 1}>
//                                                                                         {i + 1}
//                                                                                     </option>
//                                                                                 )
//                                                                             )}
//                                                                         </Select>
//                                                                         <IconButton
//                                                                             aria-label="Next page"
//                                                                             icon={<FaChevronDown />}
//                                                                             size="sm"
//                                                                             onClick={() => handleTranPageChange(user._id, currentTranPageForUser + 1)}
//                                                                             isDisabled={currentTranPageForUser === totalTranPages}
//                                                                             colorScheme="teal"
//                                                                             variant="outline"
//                                                                         />
//                                                                     </HStack>
//                                                                 </HStack>
//                                                             </VStack>
//                                                         </Box>
//                                                     </Td>
//                                                 </Tr>
//                                             )}
//                                         </React.Fragment>
//                                     );
//                                 })}
//                             </Tbody>
//                         </Table>
//                     ) : (
//                         <Center minH="200px">
//                             <Text color={colors.text}>No users found matching your search criteria.</Text>
//                         </Center>
//                     )}
//                 </TableContainer>

//                 {/* Pagination */}
//                 <Flex
//                     mt={6}
//                     justify="space-between"
//                     align="center"
//                     bg={colors.background}
//                     p={{ base: 3, md: 4 }}
//                     borderRadius="lg"
//                     flexDirection={{ base: "column", sm: "row" }}
//                     gap={{ base: 3, sm: 4 }}
//                     wrap="wrap"
//                 >
//                     {/* Results count - left aligned */}
//                     <Box 
//                     width={{ base: "full", sm: "auto" }}
//                     textAlign={{ base: "center", sm: "left" }}
//                     >
//                     <Text fontSize={{ base: "xs", sm: "sm" }}>
//                         Showing {(currentPage - 1) * usersPerPage + 1} to{' '}
//                         {Math.min(currentPage * usersPerPage, sortedUsers.length)} of {sortedUsers.length} users
//                     </Text>
//                     </Box>
                
//                     {/* Pagination controls - right aligned */}
//                     <HStack spacing={4}>
//                     <Button
//                         size={{ base: "sm", md: "md" }}
//                         onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                         isDisabled={currentPage === 1}
//                         colorScheme='teal'
//                         variant="outline"
//                         leftIcon={<Icon as={FaChevronLeft} boxSize={3} />}
//                     >
//                         <Text display={{ base: "none", sm: "block" }}>Previous</Text>
//                     </Button>
                    
//                     <HStack spacing={2}>
//                         <Text fontSize={{ base: "xs", sm: "sm" }} fontWeight="semibold">Page</Text>
//                         <Input 
//                         size={{ base: "sm", md: "md" }}
//                         type="number" 
//                         value={currentPage} 
//                         onChange={(e) => {
//                             const page = Math.min(Math.max(1, Number(e.target.value)), totalPages);
//                             setCurrentPage(page);
//                         }} 
//                         width="60px" 
//                         textAlign="center" 
//                         min={1}
//                         max={totalPages}
//                         />
//                         <Text fontSize={{ base: "xs", sm: "sm" }} fontWeight="semibold">of {totalPages}</Text>
//                     </HStack>
                    
//                     <Button
//                         size={{ base: "sm", md: "md" }}
//                         onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                         isDisabled={currentPage === totalPages}
//                         colorScheme='teal'
//                         variant="outline"
//                         rightIcon={<Icon as={FaChevronRight} boxSize={3} />}
//                         >
//                         <Text display={{ base: "none", sm: "block" }}>Next</Text>
//                     </Button>
//                     </HStack>
//                 </Flex>
//         </VStack>
//     );
// }

import {
    Button,
    useColorModeValue,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    Center,
    VStack,
    Input,
    Badge,
    Text,
    Box,
    HStack,
    IconButton,
    Select,
    Tooltip,
    Flex,
    Icon
} from '@chakra-ui/react';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useGetUsersDataMutation } from "../../slices/adminApiSlice";
import Loader from "../../components/Loader";
import { 
    FaChevronDown, 
    FaChevronUp, 
    FaChevronRight, 
    FaChevronLeft, 
    FaSearch, 
    FaFilter,
    FaUser, 
    FaEnvelope, 
    FaPhone, 
    FaStamp, 
    FaExchangeAlt,
    FaCoins, 
    FaGift, 
    FaAward, 
    FaCalendarAlt,
    FaSort,
    FaSortUp,
    FaSortDown,
    FaFileExport
} from 'react-icons/fa';

export default function UserManagementScreen() {
    // Color scheme definitions
    
    const colors = {
        primary: useColorModeValue('teal.500', 'teal.600'),
        primaryDark: useColorModeValue('teal.600', 'teal.400'),
        background: useColorModeValue('gray.50', 'gray.800'),
        cardBg: useColorModeValue('white', 'gray.700'),
        text: useColorModeValue('gray.700', 'gray.200'),
        border: useColorModeValue('gray.200', 'gray.600'),
        hover: useColorModeValue('teal.50', 'teal.900'),
        bg: useColorModeValue('teal.50', 'gray.800'),
        th: useColorModeValue('teal.600', 'teal.800')
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [usersData, setUsersData] = useState([]);
    const [usersTransactions, setUsersTransactions] = useState([]);
    const [getUsersData, { isLoading }] = useGetUsersDataMutation();
    const [sortColumn, setSortColumn] = useState('createdAt');
    const [sortOrder, setSortOrder] = useState('desc');
    const [currentPage, setCurrentPage] = useState(1);
    const usersPerPage = 10;

    // Transaction configuration - PER USER STATE
    const [userTransactionPages, setUserTransactionPages] = useState({});
    const [userTransactionFilters, setUserTransactionFilters] = useState({});
    const [userTransactionSortConfig, setUserTransactionSortConfig] = useState({});
    const [userTransactionSearch, setUserTransactionSearch] = useState({});
    const transactionsPerPage = 10;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getUsersData().unwrap();
                setUsersData(response.users || []);
                setUsersTransactions(response.transactions);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchData();
    }, [getUsersData]);

    // Sorting and filtering for users
    const filteredUsers = useMemo(() => usersData.filter(user => {
        const query = searchQuery.toLowerCase();
        return [user.email, user.phone, user.name].some(field => field?.toLowerCase().includes(query));
    }), [usersData, searchQuery]);

    const sortedUsers = useMemo(() => [...filteredUsers].sort((a, b) => {
        let aValue, bValue;

        if (sortColumn === 'reward_count') {
            aValue = a.reward_history?.length || 0;
            bValue = b.reward_history?.length || 0;
        } else {
            aValue = a[sortColumn]?.toString().toLowerCase() || '';
            bValue = b[sortColumn]?.toString().toLowerCase() || '';
        }

        return sortOrder === 'asc' ? (aValue > bValue ? 1 : -1) : (aValue > bValue ? -1 : 1);
    }), [filteredUsers, sortColumn, sortOrder]);

    const totalPages = Math.ceil(sortedUsers.length / usersPerPage);
    const paginatedUsers = useMemo(() => sortedUsers.slice((currentPage - 1) * usersPerPage, currentPage * usersPerPage), [sortedUsers, currentPage]);

    // Transaction per-user state management functions
    const getCurrentTranPageForUser = useCallback((userId) => {
        return userTransactionPages[userId] || 1;
    }, [userTransactionPages]);

    const getFilterForUser = useCallback((userId) => {
        return userTransactionFilters[userId] || 'all';
    }, [userTransactionFilters]);

    const getSortConfigForUser = useCallback((userId) => {
        return userTransactionSortConfig[userId] || { key: 'createdAt', direction: 'desc' };
    }, [userTransactionSortConfig]);

    const getSearchForUser = useCallback((userId) => {
        return userTransactionSearch[userId] || '';
    }, [userTransactionSearch]);

    // Transaction state update functions
    const handleTranPageChange = useCallback((userId, page) => {
        if (userId && page >= 1) {
            setUserTransactionPages(prev => ({
                ...prev,
                [userId]: page
            }));
        }
    }, []);

    const handleFilterChange = useCallback((userId, filter) => {
        if (userId) {
            setUserTransactionFilters(prev => ({
                ...prev,
                [userId]: filter
            }));
            // Reset to page 1 when filter changes
            setUserTransactionPages(prev => ({
                ...prev,
                [userId]: 1
            }));
        }
    }, []);

    const handleSearchChange = useCallback((userId, search) => {
        if (userId) {
            setUserTransactionSearch(prev => ({
                ...prev,
                [userId]: search
            }));
            // Reset to page 1 when search changes
            setUserTransactionPages(prev => ({
                ...prev,
                [userId]: 1
            }));
        }
    }, []);

    const handleSortChange = useCallback((userId, key) => {
        if (userId) {
            setUserTransactionSortConfig(prev => {
                const currentConfig = prev[userId] || { key: 'createdAt', direction: 'desc' };
                let direction = 'asc';
                if (currentConfig.key === key && currentConfig.direction === 'asc') {
                    direction = 'desc';
                }
                return {
                    ...prev,
                    [userId]: { key, direction }
                };
            });
        }
    }, []);

    // Reset to defaults when expanding a row
    const toggleRowExpansion = useCallback((id) => {
        setExpandedRowId(prev => {
            const newId = prev === id ? null : id;
            // Reset to defaults when expanding a new row
            if (newId !== prev && newId !== null) {
                setUserTransactionPages(prevPages => ({
                    ...prevPages,
                    [newId]: 1
                }));
                setUserTransactionFilters(prevFilters => ({
                    ...prevFilters,
                    [newId]: 'all'
                }));
                setUserTransactionSortConfig(prevSort => ({
                    ...prevSort,
                    [newId]: { key: 'createdAt', direction: 'desc' }
                }));
                setUserTransactionSearch(prevSearch => ({
                    ...prevSearch,
                    [newId]: ''
                }));
            }
            return newId;
        });
    }, []);

    // Transactions filtering and sorting
    const getSortedAndFilteredTransactions = useCallback((transactions, userId) => {
        let filtered = transactions;

        // Get user-specific filters
        const filter = getFilterForUser(userId);
        const search = getSearchForUser(userId);
        const sortConfig = getSortConfigForUser(userId);

        // Apply type filtering
        if (filter !== 'all') {
            filtered = filtered.filter(transaction => transaction.type === filter);
        }

        // Apply search filtering
        if (search) {
            filtered = filtered.filter((transaction) => {
                return (
                    transaction.invoice_id?.toLowerCase().includes(search.toLowerCase()) ||
                    transaction.type?.toLowerCase().includes(search.toLowerCase()) ||
                    transaction.amount?.toString().includes(search) ||
                    transaction.added_by_name?.toLowerCase().includes(search.toLowerCase())
                );
            });
        }

        // Apply sorting
        if (sortConfig.key) {
            filtered.sort((a, b) => {
                let aValue, bValue;

                if (sortConfig.key === 'amount') {
                    aValue = a.amount;
                    bValue = b.amount;
                } else if (sortConfig.key === 'createdAt' || sortConfig.key === 'expiration_date') {
                    aValue = new Date(a[sortConfig.key]);
                    bValue = new Date(b[sortConfig.key]);
                } else {
                    aValue = a[sortConfig.key]?.toString().toLowerCase();
                    bValue = b[sortConfig.key]?.toString().toLowerCase();
                }

                if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }

        return filtered;
    }, [getFilterForUser, getSearchForUser, getSortConfigForUser]);

    const handleSort = (column) => {
        setSortOrder(sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc');
        setSortColumn(column);
    };

    const getBadgeColor = (type) => {
        const colorMap = {
            earn: 'green',
            redeem: 'red',
            expired: 'purple',
            earn_stamp: 'blue',
            redeem_stamp: 'orange',
            expired_stamp: 'pink',
        };
        return colorMap[type] || 'gray';
    };

    const columnNames = {
        invoice_id: 'Invoice ID',
        amount: 'Amount',
        type: 'Type',
        stamps: 'Stamps',
        points: 'Points',
        added_by_name: 'Added By',
        createdAt: 'Created At',
        expiration_date: 'Expiration Date',
    };
      
    const getBadgeLabel = (type) => {
        const labelMap = {
            earn: 'Earned',
            redeem: 'Redeemed',
            expired: 'Expired',
            earn_stamp: 'Earned Stamp',
            redeem_stamp: 'Redeemed Stamp',
            expired_stamp: 'Expired Stamp',
        };
        return labelMap[type] || 'Unknown';
    };

    const transactionTypes = [
        { value: 'all', label: 'All Types' },
        { value: 'earn', label: 'Earned' },
        { value: 'redeem', label: 'Redeemed' },
        { value: 'expired', label: 'Expired' },
        { value: 'earn_stamp', label: 'Earned Stamp' },
        { value: 'redeem_stamp', label: 'Redeemed Stamp' },
        { value: 'expired_stamp', label: 'Expired Stamp' },
    ];

    // Memoized column configuration
    const columns = useMemo(() => [
        { key: 'name', label: 'Name', icon: FaUser, tooltip: 'Customer name', colorScheme: 'blue' },
        { key: 'email', label: 'Email', icon: FaEnvelope, tooltip: 'Customer email address', colorScheme: 'teal' },
        { key: 'phone', label: 'Phone', icon: FaPhone, tooltip: 'Contact phone number', colorScheme: 'cyan' },
        { key: 'current_stamps', label: 'Current Stamps', icon: FaStamp, tooltip: 'Available stamps in account', colorScheme: 'orange', numeric: true },
        { key: 'total_stamps_redeemed', label: 'Used Stamps', icon: FaExchangeAlt, tooltip: 'Total stamps redeemed', colorScheme: 'red', numeric: true },
        { key: 'current_points', label: 'Current Points', icon: FaCoins, tooltip: 'Available reward points', colorScheme: 'yellow', numeric: true },
        { key: 'total_points_redeemed', label: 'Used Points', icon: FaGift, tooltip: 'Total points redeemed', colorScheme: 'pink', numeric: true },
        { key: 'reward_count', label: 'Reward Count', icon: FaAward, tooltip: 'Number of rewards claimed', colorScheme: 'purple', numeric: true },
        { key: 'createdAt', label: 'Created At', icon: FaCalendarAlt, tooltip: 'Account creation date', colorScheme: 'gray' }
    ], []);

    // Tooltip wrapper component
    const TooltipWrapper = useCallback(({ children, label, colorScheme }) => (
        label ? (
            <Tooltip label={`Sort by ${label}`} hasArrow placement="top" bg={`${colorScheme}.500`}>
                {children}
            </Tooltip>
        ) : (
            <>{children}</>
        )
    ), []);
    
    // Enhanced export function with transactions
    const exportData = useCallback(() => {
        // Prepare data for export - combine user data with transactions
        const dataToExport = [];
        
        sortedUsers.forEach(user => {
            const userTransactions = usersTransactions.filter(t => t.user === user._id);
            
            if (userTransactions.length === 0) {
                // Add user row without transactions
                dataToExport.push({
                    'User ID': user._id,
                    'Name': user.name,
                    'Email': user.email,
                    'Phone': user.phone,
                    'Current Stamps': user.current_stamps,
                    'Used Stamps': user.total_stamps_redeemed,
                    'Current Points': user.current_points,
                    'Used Points': user.total_points_redeemed,
                    'Reward Count': user.reward_history?.length || 0,
                    'Created At': new Date(user.createdAt).toLocaleDateString('en-GB'),
                    'Transaction Type': 'No Transactions',
                    'Invoice ID': '',
                    'Amount': '',
                    'Stamps': '',
                    'Points': '',
                    'Transaction Added By': '',
                    'Transaction Created At': '',
                    'Expiration Date': ''
                });
            } else {
                // Add user data with each transaction
                userTransactions.forEach((transaction, index) => {
                    dataToExport.push({
                        'User ID': index === 0 ? user._id : '', // Show ID only on first transaction row
                        'Name': index === 0 ? user.name : '',
                        'Email': index === 0 ? user.email : '',
                        'Phone': index === 0 ? user.phone : '',
                        'Current Stamps': index === 0 ? user.current_stamps : '',
                        'Used Stamps': index === 0 ? user.total_stamps_redeemed : '',
                        'Current Points': index === 0 ? user.current_points : '',
                        'Used Points': index === 0 ? user.total_points_redeemed : '',
                        'Reward Count': index === 0 ? (user.reward_history?.length || 0) : '',
                        'Created At': index === 0 ? new Date(user.createdAt).toLocaleDateString('en-GB') : '',
                        'Transaction Type': getBadgeLabel(transaction.type),
                        'Invoice ID': transaction.invoice_id || '',
                        'Amount': transaction.amount ? new Intl.NumberFormat('en-US', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        }).format(transaction.amount) + ' MMK' : '',
                        'Stamps': transaction.stamps || '',
                        'Points': transaction.points || '',
                        'Transaction Added By': transaction.added_by_name || '',
                        'Transaction Created At': new Date(transaction.createdAt).toLocaleDateString('en-GB'),
                        'Expiration Date': transaction.expiration_date ? 
                            new Date(transaction.expiration_date).toLocaleDateString('en-GB') : 'N/A'
                    });
                });
            }
        });
      
        // Convert to CSV
        const headers = [
            'User ID', 'Name', 'Email', 'Phone', 'Current Stamps', 'Used Stamps',
            'Current Points', 'Used Points', 'Reward Count', 'Created At',
            'Transaction Type', 'Invoice ID', 'Amount', 'Stamps', 'Points',
            'Transaction Added By', 'Transaction Created At', 'Expiration Date'
        ];
        
        const csvContent = [
            headers.join(','), // Header row
            ...dataToExport.map(item => 
                headers.map(header => {
                    const value = item[header] || '';
                    // Escape commas and quotes in CSV
                    if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
                        return `"${value.replace(/"/g, '""')}"`;
                    }
                    return value;
                }).join(',')
            )
        ].join('\n');
      
        // Create download link
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:.]/g, '-');
        link.setAttribute('download', `users_with_transactions_${timestamp}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }, [sortedUsers, usersTransactions]);

    return (
        <VStack spacing={6} align="stretch" p={4} bg={colors.background} minH="100vh">
            {/* Search Header */}
                <HStack spacing={4}>
                    <Box position="relative" flex={1}>
                        <Input
                            bg={colors.cardBg}
                            placeholder="Search users by name, email or phone..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            size="lg"
                            borderRadius="lg"
                            pl={10}
                            _focus={{ 
                                borderColor: colors.primary,
                                boxShadow: `0 0 0 1px ${colors.primary}`
                            }}
                        />
                        <Box position="absolute" left={3} top="50%" transform="translateY(-50%)" color={colors.text}>
                            <FaSearch />
                        </Box>
                    </Box>
                    <Button 
                        colorScheme="teal" 
                        px={6}
                        borderRadius="lg"
                        variant="outline"
                        onClick={exportData}
                        isLoading={isLoading}
                        leftIcon={<FaFileExport />}
                        >
                        Export
                    </Button>
                </HStack>

            {/* Main Table */}
                <TableContainer
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor={colors.border}
                    bg={colors.cardBg}
                    boxShadow="sm"
                >
                    {isLoading ? (
                        <Center minH="300px">
                            <Loader color={colors.cardBg} minH={'50vh'} />
                        </Center>
                    ) : paginatedUsers.length ? (
                        <Table size="sm" variant="simple">
                           <Thead bg={colors.primary}>
                            <Tr>
                                {columns.map((column) => (
                                    <Th 
                                        key={column.key}
                                        color="white"
                                        onClick={() => handleSort(column.key)}
                                        cursor="pointer"
                                        _hover={{ 
                                            bg: colors.th,
                                            transform: 'translateY(-2px)'
                                        }}
                                        transition="all 0.2s"
                                        py={4}
                                        textAlign={column.numeric ? 'right' : 'left'}
                                        aria-sort={
                                            sortColumn === column.key ? 
                                            (sortOrder === 'asc' ? 'ascending' : 'descending') : 
                                            'none'
                                        }
                                    >
                                        <TooltipWrapper label={column.tooltip} colorScheme={column.colorScheme}>
                                            <Flex align="center" gap={3}>
                                                <Center
                                                    w={8}
                                                    h={8}
                                                    borderRadius="md"
                                                    bg={`${column.colorScheme}.100`}
                                                    color={`${column.colorScheme}.600`}
                                                    flexShrink={0}
                                                >
                                                    <Icon as={column.icon} boxSize={4} />
                                                </Center>
                                                <Text fontWeight="semibold">{column.label}</Text>
                                                <Icon
                                                    as={
                                                        sortColumn === column.key
                                                            ? sortOrder === 'asc'
                                                                ? FaSortUp
                                                                : FaSortDown
                                                            : FaSort
                                                    }
                                                    color={sortColumn === column.key ? 'white' : 'whiteAlpha.600'}
                                                    ml={1}
                                                    boxSize={4}
                                                />
                                            </Flex>
                                        </TooltipWrapper>
                                    </Th>
                                ))}
                                <Th color="white">Actions</Th>
                            </Tr>
                        </Thead>
                            <Tbody>
                                {paginatedUsers.map((user) => {
                                    const transactions = usersTransactions.filter(transaction => transaction.user === user._id);
                                    const hasTransactions = transactions.length > 0;
                                    const currentTranPageForUser = getCurrentTranPageForUser(user._id);
                                    const currentFilterForUser = getFilterForUser(user._id);
                                    const currentSearchForUser = getSearchForUser(user._id);
                                    const currentSortConfigForUser = getSortConfigForUser(user._id);
                                    const filteredTransactions = getSortedAndFilteredTransactions(transactions, user._id);
                                    const totalTranPages = Math.ceil(filteredTransactions.length / transactionsPerPage);

                                    return (
                                        <React.Fragment key={user._id}>
                                            <Tr 
                                                _hover={{ bg: colors.hover }}
                                                borderBottomWidth={expandedRowId === user._id ? '0' : '1px'}
                                                borderBottomColor={colors.border}
                                            >
                                                <Td fontWeight="medium">{user.name || 'N/A'}</Td>
                                                <Td>{user.email}</Td>
                                                <Td>{user.phone || 'N/A'}</Td>
                                                <Td textAlign={'center'} fontWeight="bold">{user.current_stamps}</Td>
                                                <Td textAlign={'center'} fontWeight="bold">{user.total_stamps_redeemed}</Td>
                                                <Td textAlign={'center'} fontWeight="bold">{user.current_points}</Td>
                                                <Td textAlign={'center'} fontWeight="bold">{user.total_points_redeemed}</Td>
                                                <Td textAlign={'center'} fontWeight="bold">{user.reward_history?.length || 0}</Td>                   
                                                <Td>{new Date(user.createdAt).toLocaleDateString('en-GB')}</Td>
                                                <Td>
                                                    <HStack spacing={2} justify="center">
                                                        <IconButton
                                                            aria-label={expandedRowId === user._id ? "Collapse transactions" : "Expand transactions"}
                                                            icon={expandedRowId === user._id ? <FaChevronUp /> : <FaChevronDown />}
                                                            onClick={() => toggleRowExpansion(user._id)}
                                                            size="sm"
                                                            colorScheme="teal"
                                                            variant="ghost"
                                                            isDisabled={!hasTransactions}
                                                            _disabled={{ opacity: 0.5, cursor: 'not-allowed' }}
                                                        />
                                                    </HStack>
                                                </Td>
                                            </Tr>

                                            {expandedRowId === user._id && (
                                                <Tr>
                                                    <Td colSpan={10} p={0}>
                                                        <Box 
                                                            bg={colors.bg}
                                                            p={4}
                                                            borderRadius="lg"
                                                            borderWidth="1px"
                                                            borderColor={colors.border}
                                                        >
                                                            <VStack spacing={4} align="stretch">
                                                                <HStack spacing={4}>
                                                                    <Box position="relative" flex={1}>
                                                                        <Input
                                                                            placeholder="Search transactions..."
                                                                            value={currentSearchForUser}
                                                                            onChange={(e) => handleSearchChange(user._id, e.target.value)}
                                                                            size="sm"
                                                                            borderRadius="md"
                                                                            pl={8}
                                                                            _focus={{ 
                                                                                borderColor: colors.primary,
                                                                                boxShadow: `0 0 0 1px ${colors.primary}`
                                                                            }}
                                                                        />
                                                                        <Box position="absolute" left={3} top="50%" transform="translateY(-50%)" color={colors.text}>
                                                                            <FaSearch size={14} />
                                                                        </Box>
                                                                    </Box>
                                                                    <Select
                                                                        value={currentFilterForUser}
                                                                        onChange={(e) => handleFilterChange(user._id, e.target.value)}
                                                                        size="sm"
                                                                        borderRadius="md"
                                                                        width="200px"
                                                                        icon={<FaFilter size={12} />}
                                                                    >
                                                                        {transactionTypes.map(type => (
                                                                            <option key={type.value} value={type.value}>
                                                                                {type.label}
                                                                            </option>
                                                                        ))}
                                                                    </Select>
                                                                </HStack>

                                                                <TableContainer
                                                                    borderRadius="lg"
                                                                    borderWidth="1px"
                                                                    borderColor={colors.border}
                                                                    bg={colors.cardBg}
                                                                    boxShadow="sm"
                                                                >
                                                                    <Table size="sm" variant="simple">
                                                                        <Thead
                                                                            bg={colors.primary}
                                                                            position="sticky"
                                                                            top={0}
                                                                            zIndex={1}
                                                                        >
                                                                            <Tr>
                                                                                {['invoice_id', 'amount', 'type', 'stamps', 'points', 'added_by_name', 'createdAt', 'expiration_date'].map((column) => (
                                                                                    <Th
                                                                                        key={column}
                                                                                        color="white"
                                                                                        onClick={() => handleSortChange(user._id, column)}
                                                                                        cursor="pointer"
                                                                                        _hover={{ bg: colors.primaryDark }}
                                                                                        py={3}
                                                                                    >
                                                                                        <HStack spacing={1}>
                                                                                            <Text>{columnNames[column] || column.replace(/_/g, ' ')}</Text>
                                                                                            {currentSortConfigForUser.key === column && (
                                                                                                currentSortConfigForUser.direction === 'asc' ? 
                                                                                                    <FaChevronUp size={10} /> : 
                                                                                                    <FaChevronDown size={10} />
                                                                                            )}
                                                                                        </HStack>
                                                                                    </Th>
                                                                                ))}
                                                                            </Tr>
                                                                        </Thead>
                                                                        <Tbody>
                                                                            {filteredTransactions
                                                                                .slice(
                                                                                    (currentTranPageForUser - 1) * transactionsPerPage,
                                                                                    currentTranPageForUser * transactionsPerPage
                                                                                )
                                                                                .map((transaction) => (
                                                                                    <Tr 
                                                                                        key={`${transaction._id}-${user._id}`} 
                                                                                        _hover={{ bg: colors.hover }}
                                                                                    >
                                                                                        <Td fontSize="sm">{transaction.invoice_id}</Td>
                                                                                        <Td fontWeight="medium">
                                                                                            {new Intl.NumberFormat('en-US', {
                                                                                                minimumFractionDigits: 0,
                                                                                                maximumFractionDigits: 0,
                                                                                            }).format(transaction.amount)} MMK
                                                                                        </Td>
                                                                                        <Td>
                                                                                            <Badge 
                                                                                                colorScheme={getBadgeColor(transaction.type)}
                                                                                                variant="subtle"
                                                                                                px={2}
                                                                                                py={1}
                                                                                                borderRadius="full"
                                                                                            >
                                                                                                {getBadgeLabel(transaction.type)}
                                                                                            </Badge>
                                                                                        </Td>
                                                                                        <Td>{transaction.stamps}</Td>
                                                                                        <Td>{transaction.points}</Td>
                                                                                        <Td>{transaction.added_by_name}</Td>
                                                                                        <Td>{new Date(transaction.createdAt).toLocaleDateString('en-GB')}</Td>
                                                                                        <Td>
                                                                                            {transaction.expiration_date ? (
                                                                                                new Date(transaction.expiration_date).toLocaleDateString('en-GB')
                                                                                            ) : (
                                                                                                <Badge colorScheme="gray" variant="outline">N/A</Badge>
                                                                                            )}
                                                                                        </Td>
                                                                                    </Tr>
                                                                                ))}
                                                                        </Tbody>
                                                                    </Table>
                                                                </TableContainer>

                                                                <HStack justify="space-between" mt={4}>
                                                                    <Text fontSize="sm" color={colors.text}>
                                                                        Showing {(currentTranPageForUser - 1) * transactionsPerPage + 1} to{' '}
                                                                        {Math.min(
                                                                            currentTranPageForUser * transactionsPerPage,
                                                                            filteredTransactions.length
                                                                        )} of {filteredTransactions.length} transactions
                                                                    </Text>
                                                                    <HStack spacing={2}>
                                                                        <IconButton
                                                                            aria-label="Previous page"
                                                                            icon={<FaChevronUp />}
                                                                            size="sm"
                                                                            onClick={() => handleTranPageChange(user._id, currentTranPageForUser - 1)}
                                                                            isDisabled={currentTranPageForUser === 1}
                                                                            colorScheme="teal"
                                                                            variant="outline"
                                                                        />
                                                                        <Select
                                                                            value={currentTranPageForUser}
                                                                            onChange={(e) => handleTranPageChange(user._id, Number(e.target.value))}
                                                                            size="sm"
                                                                            width="80px"
                                                                            borderRadius="md"
                                                                        >
                                                                            {Array.from(
                                                                                { length: totalTranPages },
                                                                                (_, i) => (
                                                                                    <option key={i + 1} value={i + 1}>
                                                                                        {i + 1}
                                                                                    </option>
                                                                                )
                                                                            )}
                                                                        </Select>
                                                                        <IconButton
                                                                            aria-label="Next page"
                                                                            icon={<FaChevronDown />}
                                                                            size="sm"
                                                                            onClick={() => handleTranPageChange(user._id, currentTranPageForUser + 1)}
                                                                            isDisabled={currentTranPageForUser === totalTranPages}
                                                                            colorScheme="teal"
                                                                            variant="outline"
                                                                        />
                                                                    </HStack>
                                                                </HStack>
                                                            </VStack>
                                                        </Box>
                                                    </Td>
                                                </Tr>
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </Tbody>
                        </Table>
                    ) : (
                        <Center minH="200px">
                            <Text color={colors.text}>No users found matching your search criteria.</Text>
                        </Center>
                    )}
                </TableContainer>

                {/* Pagination */}
                <Flex
                    mt={6}
                    justify="space-between"
                    align="center"
                    bg={colors.background}
                    p={{ base: 3, md: 4 }}
                    borderRadius="lg"
                    flexDirection={{ base: "column", sm: "row" }}
                    gap={{ base: 3, sm: 4 }}
                    wrap="wrap"
                >
                    {/* Results count - left aligned */}
                    <Box 
                    width={{ base: "full", sm: "auto" }}
                    textAlign={{ base: "center", sm: "left" }}
                    >
                    <Text fontSize={{ base: "xs", sm: "sm" }}>
                        Showing {(currentPage - 1) * usersPerPage + 1} to{' '}
                        {Math.min(currentPage * usersPerPage, sortedUsers.length)} of {sortedUsers.length} users
                    </Text>
                    </Box>
                
                    {/* Pagination controls - right aligned */}
                    <HStack spacing={4}>
                    <Button
                        size={{ base: "sm", md: "md" }}
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        isDisabled={currentPage === 1}
                        colorScheme='teal'
                        variant="outline"
                        leftIcon={<Icon as={FaChevronLeft} boxSize={3} />}
                    >
                        <Text display={{ base: "none", sm: "block" }}>Previous</Text>
                    </Button>
                    
                    <HStack spacing={2}>
                        <Text fontSize={{ base: "xs", sm: "sm" }} fontWeight="semibold">Page</Text>
                        <Input 
                        size={{ base: "sm", md: "md" }}
                        type="number" 
                        value={currentPage} 
                        onChange={(e) => {
                            const page = Math.min(Math.max(1, Number(e.target.value)), totalPages);
                            setCurrentPage(page);
                        }} 
                        width="60px" 
                        textAlign="center" 
                        min={1}
                        max={totalPages}
                        />
                        <Text fontSize={{ base: "xs", sm: "sm" }} fontWeight="semibold">of {totalPages}</Text>
                    </HStack>
                    
                    <Button
                        size={{ base: "sm", md: "md" }}
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        isDisabled={currentPage === totalPages}
                        colorScheme='teal'
                        variant="outline"
                        rightIcon={<Icon as={FaChevronRight} boxSize={3} />}
                        >
                        <Text display={{ base: "none", sm: "block" }}>Next</Text>
                    </Button>
                    </HStack>
                </Flex>
        </VStack>
    );
}